import React from 'react';

import './RailHeader.css';

const RailHeader = ({ rotate, buttonClicked }) =>
  (
    <div className="railHeader">
      <p className="railheader__content railAccount_content">
        <span>
          <span className="latoBold font22 appendRight5">Create New Account</span>
          <span className="latoBold latoIlalic font16">Register with IRCTC</span>
        </span>
        <span className="makeFlex hrtlCenter">
          <span className="createAccountLink">
            <a
              className={`${rotate ? 'btnLoader' : 'whiteText'}`}
              onClick={buttonClicked}>{rotate ? '':'CREATE ACCOUNT'}
            </a>
          </span>
        </span>
      </p>
    </div>
  );

export default RailHeader;
